import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

// Convert YouTube / Vimeo watch URLs into embeddable URLs
export function toEmbedUrl(url) {
    if (!url) return null;
    try {
        const u = new URL(url);
        const host = u.hostname.replace(/^www\./, "");
        if (host === "youtu.be") {
            return `https://www.youtube.com/embed/${u.pathname.replace(/^\//, "")}`;
        }
        if (host.endsWith("youtube.com")) {
            if (u.pathname.startsWith("/embed/")) return url;
            if (u.pathname.startsWith("/shorts/")) {
                return `https://www.youtube.com/embed/${u.pathname.split("/")[2]}`;
            }
            const v = u.searchParams.get("v");
            if (v) return `https://www.youtube.com/embed/${v}`;
        }
        if (host.endsWith("vimeo.com")) {
            const id = u.pathname.split("/").filter(Boolean).pop();
            if (id) return `https://player.vimeo.com/video/${id}`;
        }
        return url;
    } catch {
        return url;
    }
}

export const ASSETS = {
    poster: "https://customer-assets.emergentagent.com/job_raga-wisdom-center/artifacts/5ilij516_WhatsApp%20Image%202026-06-10%20at%208.53.56%20PM.jpeg",
    founder:
        "https://customer-assets.emergentagent.com/job_a8910bca-290e-4e61-8ce8-b0265eeeb9e6/artifacts/jso6io69_WhatsApp%20Image%202026-06-07%20at%205.14.57%20PM.jpeg",
    logo: "https://customer-assets.emergentagent.com/job_a8910bca-290e-4e61-8ce8-b0265eeeb9e6/artifacts/uas7cuo9_WhatsApp%20Image%202026-06-07%20at%205.13.20%20PM.jpeg",
    legacyVishnuvardhan:
        "https://customer-assets.emergentagent.com/job_a8910bca-290e-4e61-8ce8-b0265eeeb9e6/artifacts/tggye94o_WhatsApp%20Image%202026-06-07%20at%205.14.03%20PM.jpeg",
    legacyAward:
        "https://customer-assets.emergentagent.com/job_a8910bca-290e-4e61-8ce8-b0265eeeb9e6/artifacts/at457fus_WhatsApp%20Image%202026-06-07%20at%205.16.54%20PM.jpeg",
    visionConcept:
        "https://customer-assets.emergentagent.com/job_raga-wisdom-center/artifacts/2enqj1vi_WhatsApp%20Image%202026-06-13%20at%204.36.10%20PM%20%281%29.jpeg",
    visionFront:
        "https://customer-assets.emergentagent.com/job_raga-wisdom-center/artifacts/2enqj1vi_WhatsApp%20Image%202026-06-13%20at%204.36.10%20PM%20%281%29.jpeg",
    visionGardenWalk:
        "https://customer-assets.emergentagent.com/job_raga-wisdom-center/artifacts/z071ih6p_WhatsApp%20Image%202026-06-13%20at%204.32.45%20PM.jpeg",
    visionNight:
        "https://customer-assets.emergentagent.com/job_raga-wisdom-center/artifacts/h30yhfao_WhatsApp%20Image%202026-06-13%20at%204.33.31%20PM%20%281%29.jpeg",
    visionInterior:
        "https://customer-assets.emergentagent.com/job_raga-wisdom-center/artifacts/snszr8vx_WhatsApp%20Image%202026-06-13%20at%204.32.44%20PM.jpeg",
    visionDaytime:
        "https://customer-assets.emergentagent.com/job_raga-wisdom-center/artifacts/xjoeu8mf_WhatsApp%20Image%202026-06-13%20at%204.32.44%20PM%20%281%29.jpeg",
    visionCutaway:
        "https://customer-assets.emergentagent.com/job_raga-wisdom-center/artifacts/zjrmxlee_WhatsApp%20Image%202026-06-13%20at%204.32.43%20PM.jpeg",
    founderWithGuru: "/assets/founder-with-guru.jpg",
    founderTanpura:
        "https://customer-assets-lxgj4vgw.emergentagent.net/job_raga-wisdom-center/artifacts/jjh15y5g_WhatsApp%20Image%202026-07-25%20at%205.37.43%20PM.jpeg",
    riyazSession:
        "https://customer-assets-lxgj4vgw.emergentagent.net/job_raga-wisdom-center/artifacts/wvg9y7g5_WhatsApp%20Image%202026-07-25%20at%205.35.00%20PM.jpeg",
    annualDay:
        "https://customer-assets.emergentagent.com/job_raga-wisdom-center/artifacts/1fbd88dx_WhatsApp%20Image%202026-07-08%20at%209.45.50%20PM.jpeg",
    socialPourakarmika:
        "https://customer-assets.emergentagent.com/job_raga-wisdom-center/artifacts/1bjl5h5m_WhatsApp%20Image%202026-06-09%20at%209.34.34%20PM%20%281%29.jpeg",
};

export const GURUKULA = {
    name: "Shri Vishwa Bandhu Sangeetha Gurukula",
    tagline_en: "Listening to music is an art; experiencing it is meditation.",
    tagline_kn: "ಸಂಗೀತ ಕೇಳುವುದು ಕಲೆ, ಅನುಭವಿಸುವುದು ಧ್ಯಾನ.",
    phone: "8884054188",
    address: "Nagarabhavi, Bengaluru – 560072",
    mapUrl: "https://www.google.com/maps?q=12.9678338,77.5032702&z=17&hl=en",
    mapEmbed:
        "https://www.google.com/maps?q=12.9678338,77.5032702&z=17&hl=en&output=embed",
    youtube: "https://www.youtube.com/embed/nNIzfDLqsMc",
    youtubeWatch: "https://youtu.be/nNIzfDLqsMc",
    // Donation / UPI — official VPA from Canara Bank
    upiId: "324672453616001@cnrb",
    upiPayeeName: "Shri Vishwa Bandhu Sangeeta Gurukula Trust",
    upiNumber: "8880229229",
    donationEmail: "sangeetagurukula21@gmail.com",
    whatsapp: "8884054188",
    bank: {
        name: "Shri Vishwa Bandhu Sangeeta Gurukula Trust",
        bankName: "Canara Bank",
        account: "120028616001",
        ifsc: "CNRB0002614",
        branch: "Chandra Layout, Bangalore – 560040",
        passbookPdf:
            "https://customer-assets.emergentagent.com/job_raga-wisdom-center/artifacts/7bjzoyd8_324672453616001%40cnrb.pdf",
    },
};
